module.exports = __webpack_public_path__ + "media/images/div_lens/racial-black-47e98c00446d855a03caff35ed7d3d1c.png";